import type React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconHome } from '@xing-com/icons';
import { SingleSelect } from '@xing-com/menu';

import type { TrackingPropsContextType } from '../../contexts';
import { useShareToFeedMutation } from '../../hooks';
import type { OnErrorType, OnSuccessType } from '../../types';

export type QuickShareType = {
  onError: OnErrorType;
  onSuccess: OnSuccessType;
  trackingProps: TrackingPropsContextType;
  verb: 'SHARE' | 'POST';
};

export const QuickShare: React.FC<QuickShareType> = ({
  onError,
  onSuccess,
  trackingProps,
  verb,
}) => {
  const { triggerShare, loading } = useShareToFeedMutation({
    audience: 'PUBLIC',
    isQuickShare: true,
    onError,
    onSuccess,
    trackingProps,
    verb,
  });

  return (
    <SingleSelect
      {...{ loading }}
      data-qa="QUICK_SHARE_TO_START_PAGE"
      icon={IconHome}
      onClick={triggerShare}
    >
      <FormattedMessage id="SHARE_QUICKSHARE_TO_STARTPAGE" />
    </SingleSelect>
  );
};
